import templateUrl from "emun.retailer/retailer-form-submission-prompt.htm";
import controller from "emun.retailer/retailer-form-submission-prompt.controller";
import open from "webmodals/open";
import scss from 'emun.auth/pre-authorized-credit-prompt.client.scss'

export default ({
	size = "lg",
	backdrop = "static",
	placement = "center",
	preventAutoHeight = true,
	FormId,
	RefId,
	title = "Form Submission",
}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		resolve: {
			preventAutoHeight: () => preventAutoHeight,
			title: () => title,
			formId: () => FormId,
			refId: () => RefId
		},
		bindToController: true,
		controllerAs: "$ctrl"
	}).result;
